// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero--hero--2pm1b","strong":"Hero--strong--2LWOS"};